<template>
    <div id="app">
    <v-header ref="vHeader"></v-header>
    <router-view v-if="isRouterAlive" ref="main"></router-view>
    <v-footer ref="vFooter"></v-footer>
    </div>
</template>

<script>

    import vHeader from './components/header'
    import vFooter from './components/footer'

    export default {
        name: 'App',
        data: function(){
            return {
                isRouterAlive: true,
            }
        },
        provide (){
            return {
                reload: this.reload
            }
        },
        // 监听,当路由发生变化的时候执行
        watch:{
            $route(to,from){
                //头部menu
                this.closeHeaderMenu()
                //首页路由变化回调
                if(from.path == '/' && to.path == from.path && to.query != from.query){
                    this.refreshArticleList(to)
                }
                //归档路由变化回调
                if(from.path.indexOf('/archive') != -1 && to.path.indexOf('/archive') != -1){
                    this.refreshArchiveList(to);
                }
                //文章详情切换
                if(from.path.indexOf('/detail') != -1 && to.path.indexOf('/detail') != -1){
                    this.detailChange();
                }
                this.scroll();
            }
        },
        components: {
          vHeader,
          vFooter
        },
        methods: {
            reload(){
                this.isRouterAlive = false;
                this.$nextTick(function(){
                    this.isRouterAlive = true;
                })
            },
            closeHeaderMenu:function(){
                this.$refs.vHeader.menuOpen = false;
            },
            refreshArticleList: function(route){
                this.$refs.main.initPage();
                this.$refs.main.getList(route);
            },
            refreshArchiveList: function(route){
                this.$refs.main.getList(route);
            },
            detailChange:function(){
                this.$refs.main.change();
            },
            scroll: function(){
                document.body.scrollTop = 0;
                 document.documentElement.scrollTop = 0;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/App.vue